module.exports = __webpack_public_path__ + "img/favicon.ec1f381.png";